import createCacheInterceptors from '../../externals/axios-cache-interceptor';
function debounceInterceptorGenerator(config) {
    var _a = createCacheInterceptors(), requestSuccessInterceptor = _a.requestSuccessInterceptor, responseSuccessInterceptor = _a.responseSuccessInterceptor, responseErrorInterceptor = _a.responseErrorInterceptor;
    return {
        requestInterceptors: [requestSuccessInterceptor],
        responseInterceptors: [responseSuccessInterceptor, responseErrorInterceptor],
    };
}
export default debounceInterceptorGenerator;
//# sourceMappingURL=index.js.map